import React from 'react'
import arrow from '../../assets/images/arrow.png'
import { useNavigate } from 'react-router-dom';
const Discover = () => {
  const navigate = useNavigate();
    return (
        <div className="flex flex-col-reverse lg:grid lg:grid-cols-12">
          {/* Text Content */}
          <div className="col-start-1 col-end-8 bg-transparent h-full grid items-center p-6  gap-6 lg:gap-12">
            <p className="text-3xl lg:text-5xl font-semibold text-blue-800">
            Explorez notre projet
            </p>
           
            <p className="text-lg lg:text-2xl text-gray-600 leading-relaxed">
              Bienvenue sur la plateforme, où vous pouvez accéder à des données scientifiques collectées sur l'eau et la biodiversité de la région de Soliman dans le cadre du projet GIREauSOL financé par le CEPF et mise en œuvre par l’Association AEDS.
              <br />
              Le projet vise à la gestion des eaux douces de la zone humide de Soliman à travers la valorisation des données scientifiques sur l’état et la qualité des eaux et de la biodiversité de la zone en relation.
            </p>
            <div>
              <button onClick={()=> navigate("/apropos")} className="flex items-center space-x-3 p-4 bg-blue-600 text-white">
                Découvrez le projet <img className="mx-2" src={arrow} alt="arrow" />
              </button>
            </div>
          </div>
      
          {/* Image Background Section */}
          <div className="relative col-start-8 col-end-13 img-bg-discover bg-cover bg-center h-96 lg:h-full">
            <div className="absolute inset-0 bg-blue-500 opacity-60"></div>
            <div className="relative z-10 p-4 h-full grid">
              <div className="h-full place-content-end">
                <h1 className="text-4xl lg:text-6xl font-semibold text-yellow-400">Vous êtes..</h1>
              </div>
              <div className="h-full place-content-center">
                <h2 className="text-4xl lg:text-6xl font-semibold text-white">
                  Entreprise <span className="text-yellow-400">?</span>
                </h2>
                <h2 className="text-4xl lg:text-6xl font-semibold text-white">
                  Chercheur <span className="text-yellow-400">?</span>
                </h2>
              </div>
              <div className="h-full">
                <h1 className="text-3xl lg:text-5xl font-semibold text-yellow-400">Rejoignez notre communauté !</h1>
              </div>
            </div>
          </div>
        </div>
      );
      
  
}


export default Discover